import React from 'react'
import FilterIcon from 'components/icons/FilterIcon'
import styled from 'styled-components'
import { COLORS } from 'theme'
import Flex from 'components/Flex'
import { Dropdown } from 'antd'

export const FilterFlex = styled(Flex)`
  width: 50%;
`
export const FilterText = styled.p`
  margin-bottom: 0;
  margin-left: 10px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${COLORS.GREY_T_60};
`
export const StyledDropdown = styled(Dropdown)`
  width: 89%;
  cursor: pointer;
  height: 50px;
  padding-left: 10px;
  border-right: 1px solid ${COLORS.GREY_T_90};
`

export const FlexWrap = styled(Flex)`
  width: ${props => (props?.width ? props?.width : '63%')};
  position: relative;
`

const FilterDivWithoutSearch = ({
  overlayMenu,
  label = 'Filter',
  trigger = 'click',
  open = false,
  setOpen,
  width = '63%',
}) => {
  const handleDropDownOpen = e => {
    e.preventDefault()
    setOpen(false)
  }
  const visibleChange = flag => {
    setOpen(flag)
  }
  return (
    <FlexWrap width={width} id="filterDropdown">
      <StyledDropdown
        overlay={overlayMenu}
        trigger={[trigger]}
        visible={open}
        onVisibleChange={visibleChange}
        getPopupContainer={() => document.getElementById('filterDropdown')}
      >
        <FilterFlex centerVertically onClick={e => handleDropDownOpen(e)}>
          <FilterIcon />
          <FilterText>{label}</FilterText>
        </FilterFlex>
      </StyledDropdown>
    </FlexWrap>
  )
}

export default FilterDivWithoutSearch
